import { render, staticRenderFns } from "./systermAuthMenuTemplate.vue?vue&type=template&id=71492994&scoped=true&"
import script from "./systermAuthMenuTemplate.vue?vue&type=script&lang=js&"
export * from "./systermAuthMenuTemplate.vue?vue&type=script&lang=js&"
import style0 from "./systermAuthMenuTemplate.vue?vue&type=style&index=0&id=71492994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71492994",
  null
  
)

export default component.exports